export default {
  description: `Bir gün şiirlerimdeki Türkçe sözcükler dediler ki: "Arkadaş, sen aynı şiirinde hem Türkçe bir sözcük kullanıp anne diyorsun hem de yabancı bir sözcük kullanıp valide diyorsun. Dizelerin içine yabancı bir sözcük koyarsan bu zengin bir dil kullanımı olmuyor. Ya bizi seç ya da onları..." Ben de başladım güzel dilimiz Türkçeyle yazmaya.<nl> Geçen hafta bir seminer sonrası çok sevdiğim şair arkadaşımla bahçede biraz oturduk. Bana iyice yaklaşarak "selfie" pozu ver de bu anı ölümsüzleştirelim, dedi. Birden durgunlaştım. Nedenini sorduğunda, Türk Dil Kuru­ mu vatandaşlardan gelen öneriler doğrultusunda "kendi fotoğrafını çekmek" anlamına gelen "selfie" yerine Türkçe karşılık olarak "özçekim" sözcüğünü seçti, sen de özçekimi kullansaydın mutlu olurdum, dedim.`,
  title: `Bu metinlerde vurgulanmak istenen ortak yön aşağıdakilerden hangisidir?`,
  options: [
    {
      title: `Söz varlığını zenginleştirme konusuna önem vermeleri`,
      isTrue: true
    },
    {
      title: `Sözcüklere Türkçe karşılık bulmada toplumun görüşünü dikkate almaları`,
      isTrue: false
    },
    {
      title: `Yabancı sözcüklerin yerine Türkçelerini kullanmayı özendirmeleri`,
      isTrue: false
    },
    {
      title: `Yabancı dillerden alınmış ve dilimize yerleşmiş sözcükleri sıkça kullanmaları`,
      isTrue: false
    }
  ],
  id: 3
};



// WEBPACK FOOTER //
// ./src/assets/sorular/lgs/3.js